export default [
    // {
    //     path: "/festival",
    //     name: "Festival",
    //     meta: {
    //       title: "节日慰问",
    //       keepAlive: false,
    //       auth: false,
    //       home: false,
    //       backgroundColor: "#fff"
    //     },
    //     component: () => import("@views/external/Festival.vue")
    // }, {
    //     path: "/festival/festivalList",
    //     name: "FestivalList",
    //     meta: {
    //       title: "五一",
    //       keepAlive: false,
    //       auth: false,
    //       home: false,
    //       backgroundColor: "#fff"
    //     },
    //     component: () => import("@views/external/FestivalList.vue")
    // }
];